import { injectable } from 'inversify-props';
import BaseService from '../base-service';

export interface IExpandirParticularidadeRequest {
  usuarioId: number;
  expandirPorPadrao: boolean;
}

export interface IExpandirParticularidadeResponse {
  expandirPorPadrao: boolean;
}

@injectable()
export default class ConfigUsuarioService extends BaseService {
  async saveExpandirParticularidadePorPadrao(request: IExpandirParticularidadeRequest): Promise<void> {
    try {
      await this.httpService.post(
        Object,
        `${this.getApiPath()}/crm/config/usuario/${request.usuarioId}/flag-expandir-particularidades`,
        JSON.stringify(request.expandirPorPadrao),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
    } catch (error) {
      throw new Error('Erro ao salvar configuração de expandir particularidades');
    }
  }

  async getExpandirParticularidadeStatus(usuarioId: number): Promise<IExpandirParticularidadeResponse> {
    try {
      const response = await this.httpService.get(
        Boolean,
        `${this.getApiPath()}/crm/config/usuario/${usuarioId}/flag-expandir-particularidades`,
      );

      const expandirPorPadrao = Boolean(response);
      return { expandirPorPadrao };
    } catch (error) {
      return { expandirPorPadrao: false };
    }
  }
}
